export let hresh1xColumns = () => {
  let indexColumns = [{
    key: 'dtemistk',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'desc_codpunsh',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_typpun',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'PunishmentPeriod',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 300px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtestart',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'dteend',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 150px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRESH1XC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }]
  let detailTab3Columns = [{
    key: 'code',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'detail',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'unit',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '100',
    style: 'min-width: 100px;'
  }, {
    key: 'amt',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '110',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'adjp',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '120',
    class: 'align-right',
    style: 'min-width: 80px;'
  }, {
    key: 'amtcded',
    name: '',
    labelCodapp: 'HRPM4GEC4',
    labelIndex: '130',
    class: 'align-right',
    style: 'min-width: 100px;'
  }]

  return {
    en: {
      index: indexColumns,
      detailTab3: detailTab3Columns
    },
    th: {
      index: indexColumns,
      detailTab3: detailTab3Columns
    }
  }
}
export let hresh1xMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hresh1x.js